import React, { useState } from 'react'
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';

import { fetchRequest } from '../fetchRequest';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image'
import InputGroup from 'react-bootstrap/InputGroup';

const NfcCheckModal = ({ onCloseNfcModal = {} }) => {
    const { currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [nfcCode, setNfcCode] = useState('');

    const [result, setResult] = useState(null)

    const submitNfcCode = (nfcCode = null) => {
        if (nfcCode?.length > 0) {
            setResult(null)
            setLoading(true);
            setNfcCode('');
            let bodyParams = {
                school: currentUser?.school,
                nfcCode
            }
            fetchRequest("app/kiosk/nfc-check", 'POST', bodyParams)
                .then(res => {
                    setLoading(false);
                    if (res?.success) {
                        setResult({
                            nfc: res?.nfc,
                            error: null,
                            user: res?.user
                        })
                    } else {
                        setResult({
                            nfc: res?.nfc,
                            error: res?.message || 'Картын мэдээлэл олдсонгүй',
                            user: null
                        })
                        toast.warning(res?.message || 'Картын мэдээлэл олдсонгүй', {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        })
                    }
                }).catch(e => {
                    setLoading(false);

                    toast.warning('Хүсэлт илгээхэд алдаа гарлаа', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    })
                })
        }
    }

    return (
        <>
            <Modal
                show={true}
                backdrop="static"
                dialogClassName="modal-95w"
                onHide={onCloseNfcModal}>
                <Modal.Body className={'p-0'} style={{ display: 'flex', flexDirection: 'column' }}>
                    <Row style={{ marginTop: 20, marginBottom: 10 }}>
                        <Col className='text-center'>
                            <Button type={'button'} className='btn-close-shop' variant="secondary" onClick={onCloseNfcModal}>
                                <Image
                                    alt='close'
                                    className="icon-close"
                                    src={`/assets/images/ic_close.png`} />
                            </Button>
                        </Col>
                    </Row>

                    <div style={{ height: '100%', paddingTop: '10%' }}>
                        <Row>
                            <Col xs={1} md={3}></Col>
                            <Col xs={10} md={6}>
                                <Row className={'mt-20'}>
                                    <label>NFC code:</label>
                                    <InputGroup style={{
                                        zIndex: '0 !important',
                                    }}>
                                        <Form.Control aria-label="NFC code"
                                            type={'number'}
                                            onKeyDown={(e) => {
                                                if (e?.key?.toLowerCase() === 'enter') {
                                                    submitNfcCode(nfcCode)
                                                }
                                            }}
                                            onWheel={(e) => e.target.blur()}
                                            onChange={(e) => {
                                                setNfcCode(e?.target?.value)
                                            }}
                                            value={nfcCode}
                                            placeholder="Карт уншуулна уу" />
                                        <Button
                                            type={'button'}
                                            variant="outline-secondary"
                                            className='btn-search'
                                            onClick={() => {
                                                submitNfcCode(nfcCode)
                                            }}
                                        >
                                            <Image
                                                alt='search'
                                                className="icon-dashboard"
                                                src={`/assets/images/ic_search.png`} />
                                        </Button>
                                    </InputGroup>
                                </Row>

                                <Row className={'mt-20 text-center'}>
                                    {loading && <Spinner animation="border" size='md' style={{ margin: 'auto' }} />}
                                    <p>{loading ? 'Түр хүлээнэ үү' : 'Сурагчийн / Ажилтны картаа уншуулна уу'}</p>
                                </Row>

                                {
                                    result && <Row className={'mt-20 text-center p-2'} style={{
                                        border: 'solid 1px rgba(255, 42, 0, 0.5)',
                                        borderRadius: 5
                                    }}>
                                        <Col md={1} />
                                        <Col md={10} className='text-center'>
                                            <Row>
                                                <p>NFC: <b>{result?.nfc}</b></p>
                                            </Row>
                                            {
                                                result?.user
                                                    ? <Row>
                                                        <div style={{
                                                            display: 'inline-flex',
                                                            width: '100%',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <img src={result?.user?.avatar || '/assets/images/avatar_placeholder.png'} style={{
                                                                width: 100,
                                                                height: 100
                                                            }}
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = "/assets/images/avatar_placeholder.png";
                                                                }}
                                                            />
                                                            <div style={{
                                                                textAlign: 'left',
                                                                marginLeft: 20
                                                            }}>
                                                                <p className='m-0'>Овог: {result?.user?.lastName}</p>
                                                                <p className='m-0'>Нэр: {result?.user?.firstName}</p>
                                                                <p className='m-0'>Код: {result?.user?.code}</p>
                                                                {
                                                                    result?.user?.userType === 'STUDENT' && <p>Анги: {result?.user?.className}</p>
                                                                }
                                                            </div>
                                                        </div>
                                                    </Row>
                                                    :
                                                    result?.error &&
                                                    <Row className='text-center'>
                                                        <p>{result?.error}</p>
                                                    </Row>
                                            }
                                            <Row className='mt-2'>
                                                <Col md={12} className="text-center">
                                                    <Button type={'button'}
                                                        style={{
                                                            lineHeight: '15px'
                                                        }}
                                                        className='btn-clear-product'
                                                        onClick={() => setResult(null)}>
                                                        <Image
                                                            alt='clear'
                                                            className="icon-clear"
                                                            src={`/assets/images/ic_clear.png`} />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                            <Col xs={1} md={3}></Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );

}
export default NfcCheckModal;